"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _core = require("@material-ui/core");

var _Screen = require("egov-ui-kit/common/common/Screen");

var _Screen2 = _interopRequireDefault(_Screen);

var _commons = require("egov-ui-framework/ui-utils/commons");

var _components = require("egov-ui-kit/components");

var _commons2 = require("egov-ui-kit/utils/commons");

var _PTServiceUrls = require("egov-ui-kit/common/PTServiceUrls");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Acknowledgement() {
  var status = (0, _commons.getQueryArg)(window.location.href, "status");
  var successTailText = "Transcation ID - ";
  var successHeaderMessage = "Your payment was successful!";
  var failureHeaderMessage = "Your payment was unsuccessful!";
  var transcId = localStorage.getItem("TransactionIDD") || "";
  var iconType = status === "success" ? "done" : "close";
  var backgroundColor = status === "success" ? "#39CB74" : "#E54D42";
  var message = status === "success" ? successHeaderMessage : failureHeaderMessage;

  var handlePrintButton = function handlePrintButton() {
    var requestData = {
      RequestData: { txnTypeId: "30", txnId: transcId }
    };
    (0, _commons2.reportPrintHandler)(_PTServiceUrls.urlPaymentReceiptDownload, [], requestData, "All Bill Report");
  };

  var handleReturnToHomeButton = function handleReturnToHomeButton() {
    return (0, _commons2.setRoute)("/withoutAuth/online-payment");
  };

  return _react2.default.createElement(
    _Screen2.default,
    { xs: { p: 2 } },
    _react2.default.createElement(
      _core.Card,
      { style: { margin: "61px 15px 19px", height: "auto", width: "unset", display: "block" }, variant: "outlined" },
      _react2.default.createElement(
        _core.Grid,
        { container: true, justifyContent: "center", alignItems: "center", style: { margin: "23px 19px" } },
        _react2.default.createElement(_core.Grid, { item: true, xs: 3, style: { paddingLeft: "15rem" } }),
        _react2.default.createElement(
          _core.Grid,
          { item: true, xs: 1 },
          _react2.default.createElement(
            _core.Avatar,
            { style: { width: "72px", height: "72px", backgroundColor: backgroundColor } },
            _react2.default.createElement(
              _core.Icon,
              { color: "white", style: { fontSize: "80px" } },
              _react2.default.createElement(
                "i",
                { className: "material-icons", style: { fontSize: "80px" } },
                iconType
              )
            )
          )
        ),
        _react2.default.createElement(
          _core.Grid,
          { item: true, xs: 4 },
          _react2.default.createElement(
            "h2",
            { style: { color: "black" } },
            message
          ),
          _react2.default.createElement(
            "h5",
            { style: { color: "black" } },
            successTailText,
            transcId
          )
        ),
        _react2.default.createElement(_core.Grid, { item: true, xs: 4 })
      )
    ),
    _react2.default.createElement(
      _core.Grid,
      { container: true },
      _react2.default.createElement(_core.Grid, { item: true, xs: 8 }),
      _react2.default.createElement(
        _core.Grid,
        { item: true, xs: 4 },
        _react2.default.createElement(
          _core.Grid,
          { container: true },
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 6 },
            _react2.default.createElement(_components.MaterialButton, {
              label: "Print Receipt",
              variant: "outlined",
              color: "secondary",
              style: (0, _extends3.default)({}, _commons2.styles.searchButton, { width: "80%", height: "0px" }),
              onClick: handlePrintButton
            })
          ),
          _react2.default.createElement(
            _core.Grid,
            { item: true, xs: 6 },
            _react2.default.createElement(_components.MaterialButton, {
              label: "Return to Home",
              variant: "outlined",
              color: "secondary",
              style: (0, _extends3.default)({}, _commons2.styles.resetButton, { height: "0px", width: "80%" }),
              onClick: handleReturnToHomeButton
            })
          )
        )
      )
    )
  );
}

exports.default = Acknowledgement;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/OnlinePayment/acknowledgement.js
// module id = 3362
// module chunks = 1137